import { Box } from "@mui/system";
import { Typography } from "@material-ui/core";
// components
import PageHeader from "../../components/PageHeader";

export default function TerminiCondizioni() {
  return (
    <Box
      sx={{
        padding: {
          xs: "20px",
          sm: "35px",
          md: "54px",
        },
        paddingBottom: {
          xs: "100px !important",
          md: "150px !important",
        },
      }}
    >
      <PageHeader title="Termini e Condizioni" />

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          1. Oggetto del Servizio
        </Typography>
        <Typography style={styles.text}>
          I presenti Termini e Condizioni disciplinano l'accesso e l'utilizzo della piattaforma digitale
          "CARe-Together" (di seguito, la "Piattaforma") gestita da The Bloc Italy.
        </Typography>
        <Typography style={styles.text}>
          La Piattaforma consente agli utenti registrati (di seguito, i "Clienti") di entrare in contatto con
          professionisti terzi (di seguito, i "Professionisti") per la richiesta di servizi di caregiving,
          fisioterapia e nutrizione (di seguito, i "Servizi").
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          2. Natura del Servizio e Ruolo di The Bloc Italy
        </Typography>
        <Typography style={styles.text}>
          The Bloc Italy fornisce esclusivamente un servizio di intermediazione tecnologica tra Clienti e
          Professionisti. The Bloc Italy non eroga direttamente alcun Servizio e non svolge attività sanitaria,
          medica o assistenziale.
        </Typography>
        <Typography style={styles.text}>
          L'utilizzo della Piattaforma implica l'accettazione del fatto che The Bloc Italy non è parte del
          rapporto tra Cliente e Professionista.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          3. Registrazione e Account
        </Typography>
        <Typography style={styles.text}>
          Per accedere ai Servizi è richiesta la registrazione alla Piattaforma. La registrazione è riservata a
          persone fisiche che abbiano compiuto il diciottesimo anno di età.
        </Typography>
        <Typography style={styles.text}>
          Il Cliente si impegna a:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • fornire informazioni veritiere, aggiornate e complete;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • mantenere riservate le credenziali di accesso;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • essere responsabile di tutte le attività svolte tramite il proprio account.
        </Typography>
        <Typography style={styles.text}>
          The Bloc Italy si riserva il diritto di sospendere o cancellare account in caso di violazione dei
          presenti Termini.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          4. Prenotazione Servizi
        </Typography>
        <Typography style={styles.text}>
          Attraverso la Piattaforma, eventualmente con il supporto dello Steward di cui all'art. 4-bis, il
          Cliente può richiedere la prenotazione di un Servizio. La conferma e l'erogazione del Servizio sono
          rimesse esclusivamente al Professionista.
        </Typography>
        <Typography style={styles.text}>
          Eventuali condizioni specifiche relative a disponibilità, modalità di esecuzione e compensi sono
          stabilite dal Professionista.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          4-bis. Ruolo dello Steward
        </Typography>
        <Typography style={styles.text}>
          The Bloc Italy mette a disposizione del Cliente, ove ritenuto opportuno in ragione delle condizioni
          del Cliente stesso, un operatore di supporto (di seguito lo "Steward").
        </Typography>
        <Typography style={styles.text}>
          Lo Steward assiste il Cliente esclusivamente nelle operazioni di compilazione e inserimento dei dati
          richiesti in fase di registrazione alla Piattaforma, su espressa richiesta del Cliente.
        </Typography>
        <Typography style={styles.text}>
          Lo Steward:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • opera su incarico di The Bloc Italy e non fornisce, in alcun caso, consulenza sanitaria, medica,
          assistenziale o professionale di alcun genere;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • non è responsabile della correttezza, completezza e veridicità dei dati forniti dal Cliente, che
          rimangono di esclusiva responsabilità del Cliente medesimo;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • non interviene nel rapporto contrattuale tra il Cliente e il Professionista, né nell'erogazione dei
          Servizi.
        </Typography>
        <Typography style={styles.text}>
          L'assistenza dello Steward ha natura meramente tecnica e operativa, limitata alla fase di
          registrazione, e non comporta l'instaurazione di alcun rapporto contrattuale ulteriore rispetto a
          quanto disciplinato dai presenti Termini.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          5. Ruolo della Piattaforma e Natura dei servizi
        </Typography>
        <Typography style={styles.text}>
          L'utente riconosce e accetta espressamente che:
        </Typography>
        <Typography style={styles.text}>
          a) The Bloc Italy non è una struttura sanitaria né una società tra professionisti e non eroga in
          alcun modo prestazioni mediche, psicologiche o sanitarie, inclusi i Servizi, la cui erogazione è
          esclusivamente a carico dei Professionisti. Pertanto, The Bloc Italy non potrà essere in alcun modo
          qualificata o presentata come struttura sanitaria o fornitore delle prestazioni offerte dai
          Professionisti;
        </Typography>
        <Typography style={styles.text}>
          b) The Bloc Italy gestisce la Piattaforma e fornisce esclusivamente servizi di natura tecnologica e
          di supporto in relazione all'organizzazione dell'erogazione dei Servizi da parte dei Professionisti,
          senza intervenire in alcun modo nella loro esecuzione, né esercitare poteri di direzione,
          coordinamento o controllo sull'attività dei Professionisti. I Professionisti restano gli unici
          responsabili dell'erogazione delle prestazioni, nonché dell'adempimento di tutti gli obblighi
          normativi e deontologici applicabili, ivi inclusi, a titolo esemplificativo, l'acquisizione del consenso
          informato e la corretta tenuta della documentazione;
        </Typography>
        <Typography style={styles.text}>
          c) la prenotazione e l'erogazione di un Servizio da parte di un Cliente non comportano
          l'instaurazione di alcun rapporto contrattuale tra il Cliente e The Bloc Italy, ma esclusivamente tra
          il Cliente e il Professionista che accetta di erogare il Servizio;
        </Typography>
        <Typography style={styles.text}>
          d) i Professionisti operano in totale autonomia e indipendenza, senza alcun vincolo di
          subordinazione o di altra natura nei confronti di The Bloc Italy, e sono i soli responsabili dei
          Servizi erogati ai Clienti;
        </Typography>
        <Typography style={styles.text}>
          e) i Professionisti sono gli unici responsabili della propria iscrizione agli albi professionali, ove
          richiesto, nonché della stipula e del mantenimento di idonee coperture assicurative per i rischi
          derivanti dall'attività svolta.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          6. Limitazioni di Responsabilità
        </Typography>
        <Typography style={styles.text}>
          In nessun caso The Bloc Italy sarà responsabile per danni, ai Clienti, ai Professionisti o a terzi
          risultanti, direttamente o indirettamente, dalla fruizione di un Servizio da parte del Cliente, inclusi,
          a titolo esemplificativo e non esaustivo, danni alla persona, errori professionali, omissioni,
          interruzioni del servizio o mancato raggiungimento dei risultati attesi.
        </Typography>
        <Typography style={styles.text}>
          Il Cliente riconosce e accetta che l'utilizzo della Piattaforma avviene sotto la propria esclusiva
          responsabilità e che The Bloc Italy agisce esclusivamente quale intermediario tecnologico tra
          Clienti e Professionisti.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          7. Obblighi del Cliente
        </Typography>
        <Typography style={styles.text}>
          Il Cliente si impegna a:
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • utilizzare la Piattaforma in modo conforme alla normativa vigente;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • non utilizzare il servizio per finalità illecite o fraudolente;
        </Typography>
        <Typography style={{ ...styles.text, ...styles.indent }}>
          • non interferire con il corretto funzionamento della Piattaforma.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          8. Esclusione di Emergenza Medica
        </Typography>
        <Typography style={styles.text}>
          La Piattaforma non è destinata alla gestione di emergenze mediche o situazioni urgenti. In tali
          casi, il Cliente è tenuto a contattare immediatamente i servizi di emergenza competenti.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          9. Proprietà Intellettuale
        </Typography>
        <Typography style={styles.text}>
          Tutti i contenuti della Piattaforma, inclusi testi, grafiche, loghi e software, sono di proprietà di
          The Bloc Italy o dei rispettivi titolari e sono protetti dalla normativa applicabile in materia di
          proprietà intellettuale.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          10. Protezione dei Dati Personali
        </Typography>
        <Typography style={styles.text}>
          Il trattamento dei dati personali dei Clienti è disciplinato dall'Informativa Privacy, disponibile
          sulla Piattaforma.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          11. Modifiche dei Termini
        </Typography>
        <Typography style={styles.text}>
          The Bloc Italy si riserva il diritto di modificare i presenti Termini e Condizioni in qualsiasi momento.
          Le modifiche saranno comunicate al Cliente con un preavviso di almeno 15 (quindici) giorni prima
          della loro entrata in vigore, tramite notifica sulla Piattaforma o all'indirizzo email indicato in fase
          di registrazione.
        </Typography>
        <Typography style={styles.text}>
          Il Cliente che non intenda accettare le modifiche ha facoltà di recedere dai presenti Termini entro
          il termine di preavviso indicato, cessando l'utilizzo della Piattaforma. Il proseguimento
          dell'utilizzo della Piattaforma successivamente all'entrata in vigore delle modifiche costituisce
          accettazione delle stesse.
        </Typography>
      </Box>

      <Box style={styles.boxParagraph}>
        <Typography style={{ ...styles.italic, ...styles.bold }}>
          12. Risoluzione delle controversie e Legge applicabile
        </Typography>
        <Typography style={styles.text}>
          I presenti Termini e Condizioni sono regolati dalla legge italiana.
        </Typography>
        <Typography style={styles.text}>
          In caso di controversia relativa all'interpretazione o all'esecuzione dei presenti Termini, le Parti
          si impegnano a ricercare in buona fede una soluzione amichevole prima di adire l'autorità
          giudiziaria.
        </Typography>
        <Typography style={styles.text}>
          Fermo quanto precede, per ogni controversia sarà competente il Foro di Milano.
        </Typography>
      </Box>
    </Box>
  );
}

const styles = {
  boxParagraph: {
    marginBottom: "20px",
  },
  text: {
    marginBottom: "8px",
    display: "block",
  },
  italic: {
    fontStyle: "italic",
  },
  bold: {
    fontWeight: "bold",
  },
  indent: {
    paddingLeft: "20px",
    display: "block",
    marginBottom: "6px",
  },
};
